import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { categoryShort, importanceLabel, statusLabel, statusClass, formatDate } from "@/lib/content";
import { Plus, Pencil, Eye, Trash2 } from "lucide-react";

export default function ArticlesList() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/articles").then(({ data }) => setArticles(data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (id, title) => {
    if (!window.confirm(`Supprimer définitivement « ${title} » ?`)) return;
    await api.delete(`/admin/articles/${id}`);
    load();
  };

  return (
    <div data-testid="admin-articles-list">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h1 className="font-serif text-3xl text-bz-navy">Décryptages</h1>
        <Link to="/admin/articles/new" data-testid="articles-new" className="inline-flex items-center gap-2 bg-bz-navy px-5 py-3 text-xs uppercase tracking-[0.15em] text-bz-ivory transition-colors hover:bg-bz-petrol">
          <Plus size={16} strokeWidth={1.8} /> Nouveau
        </Link>
      </div>

      {loading ? (
        <p className="mt-10 text-bz-slate">Chargement…</p>
      ) : (
        <div className="mt-8 overflow-x-auto border border-bz-line">
          <table className="w-full min-w-[720px] text-left text-sm">
            <thead className="border-b border-bz-line bg-bz-ivory2 text-xs uppercase tracking-[0.1em] text-bz-slate">
              <tr>
                <th className="px-5 py-4">Titre</th>
                <th className="px-5 py-4">Catégorie</th>
                <th className="px-5 py-4">Importance</th>
                <th className="px-5 py-4">Statut</th>
                <th className="px-5 py-4">Mise à jour</th>
                <th className="px-5 py-4 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-bz-line">
              {articles.map((a) => (
                <tr key={a.id} data-testid={`article-row-${a.id}`} className="bg-white">
                  <td className="px-5 py-4 font-medium text-bz-navy">{a.title}</td>
                  <td className="px-5 py-4 text-bz-slate">{categoryShort(a.category)}</td>
                  <td className="px-5 py-4 text-bz-slate">{importanceLabel(a.importance)}</td>
                  <td className="px-5 py-4">
                    <span className={`inline-flex px-2.5 py-1 text-[0.6rem] uppercase tracking-[0.1em] ${statusClass(a.status)}`}>{statusLabel(a.status)}</span>
                  </td>
                  <td className="px-5 py-4 text-bz-slate">{formatDate(a.updated_at)}</td>
                  <td className="px-5 py-4">
                    <div className="flex items-center justify-end gap-3">
                      <Link to={`/admin/articles/${a.id}/preview`} data-testid={`preview-${a.id}`} title="Prévisualiser" className="text-bz-slate hover:text-bz-petrol"><Eye size={18} strokeWidth={1.5} /></Link>
                      <Link to={`/admin/articles/${a.id}/edit`} data-testid={`edit-${a.id}`} title="Modifier" className="text-bz-slate hover:text-bz-petrol"><Pencil size={18} strokeWidth={1.5} /></Link>
                      <button onClick={() => remove(a.id, a.title)} data-testid={`delete-${a.id}`} title="Supprimer" className="text-bz-slate hover:text-red-600"><Trash2 size={18} strokeWidth={1.5} /></button>
                    </div>
                  </td>
                </tr>
              ))}
              {articles.length === 0 && (
                <tr><td colSpan={6} className="px-5 py-8 text-center text-bz-slate">Aucun décryptage.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
